import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config.model';
import { environment } from 'src/environments/environment';


@Injectable()
export class AppConfigService {

  public appConfig: Config;

  constructor(private http: HttpClient) {
  }

  loadAppConfig() {
    return this.http.get('/assets/data/appConfig.json')
      .toPromise()
      .then((data: Config) => {
        this.appConfig = data;
        this.appConfig.baseUrl = environment.baseUrl;
      });
  }
}
